import BaseService from "./BaseService";

class AdditionalExpTypeService {
  static async GetAdditionalExpenseTypes(tennantId, token) {
    try {
      return await BaseService.get("additional-expense-types", token, { tennantId });
    } catch (error) {
      console.error("There was an error fetching the additional expense types!", error);
      throw error;
    }
  }
}

export default AdditionalExpTypeService;
